import { useMemo } from "react";
import type { Payment } from "@kanda-libs/ks-frontend-services";
import useSearchWords from "hooks/useSearchWords";
import useQuery from "hooks/useQuery";

export interface PaymentCellPropsHook {
  priceColor: string;
  tagColor: string;
  classNames: {
    wrapperClassName: string;
    poundsClassName: string;
    centsClassName: string;
  };
  searchWords: string[];
}

export default function usePaymentCellProps(
  status: Payment["status"],
  type: string
): PaymentCellPropsHook {
  const [query] = useQuery("payments");

  const searchWords = useSearchWords(query);

  const priceColor = status === "paid" ? "green-500" : "neutral-600";

  const tagColor = useMemo(() => {
    if (type === "loan") return "green";
    if (type === "cash") return "violet";
    return "blue";
  }, [type]);

  const classNames = {
    wrapperClassName: "my-auto",
    poundsClassName: "text-14-22-em",
    centsClassName: "text-14-22-em",
  };

  return {
    priceColor,
    tagColor,
    classNames,
    searchWords,
  };
}
